import type { DemoKey } from '../types';

export const tl: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Matematika · Estadistika',
  'app.title': 'Estadistika',
  'panel.experiment': 'Eksena',
  'panel.params': 'Mga Parameter',

  'exp.survey-explorer.title': 'Survey explorer',
  'exp.survey-explorer.desc': 'Pumili ng column; ang demo ang pipili ng tamang buod.',
  'exp.distribution-sculptor.title': 'Eskultor ng distribusyon',
  'exp.distribution-sculptor.desc': 'I-drag ang mga punto, tingnan ang tugon ng mga istatistika.',
  'exp.two-variable-lab.title': 'Lab para sa dalawang variable',
  'exp.two-variable-lab.desc': 'Scatter, fit, at tanong tungkol sa sanhi.',
  'exp.sampling-lab.title': 'Lab ng pag-sasample',
  'exp.sampling-lab.desc': 'Paano ginagalaw ng teknik at laki ang sample mean.',
  'exp.probability-diagrams.title': 'Mga diagram ng probabilidad',
  'exp.probability-diagrams.desc': 'Tanawin sa Venn at puno para sa mga compound event.',

  'type.qualitative-nominal.label': 'Kalidad · nominal',
  'type.qualitative-nominal.def': 'Mga kategoryang walang inherent order.',
  'type.qualitative-ordinal.label': 'Kalidad · ordinal',
  'type.qualitative-ordinal.def': 'Mga kategoryang may makabuluhang ayos.',
  'type.qualitative-multi.label': 'Kalidad · maraming halaga',
  'type.qualitative-multi.def': 'Maaaring maraming tag sa bawat obserbasyon.',
  'type.quantitative-discrete.label': 'Dami · diskreto',
  'type.quantitative-discrete.def': 'Mga numero sa nakatakdang hakbang.',
  'type.quantitative-continuous.label': 'Dami · tuluy-tuloy',
  'type.quantitative-continuous.def': 'Mga numero sa tuluy-tuloy na sukat.',

  'column.name.label': 'Pangalan ng estudyante',
  'column.height_cm.label': 'Taas',
  'column.shoe_size_eu.label': 'Sukat ng sapatos (EU)',
  'column.study_hours.label': 'Oras ng pag-aaral / linggo',
  'column.test_score.label': 'Iskor sa pagsusulit',
  'column.sports_played.label': 'Mga isports',
  'column.eye_color.label': 'Kulay ng mata',
  'column.commute_min.label': 'Biyahe',
  'column.grade_year.label': 'Antas',
  'column.homework_effort.label': 'Sipag sa takdang-aralin',
  'column.ice-cream-sales.label': 'Benta ng sorbetes',
  'column.drownings.label': 'Mga pagkalunod',
  'column.month.label': 'Buwan',
  'column.storks.label': 'Mga tagak',
  'column.births.label': 'Mga panganganak',
  'column.country_area_km2.label': 'Lawak ng bansa',
  'column.sleep_hours.label': 'Oras ng tulog',
  'column.reaction_ms.label': 'Oras ng reaksiyon',

  'dataset.master-survey.label': 'Survey ng klase',
  'dataset.master-survey.desc': '30 sinasagisag na estudyante.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Sorbetes vs pagkalunod',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Pareho silang umaakyat-bumababa kasabay ng panahon. Hindi sanhi ng benta ang pagkalunod.',
  'dataset.spurious-storks-vs-births.label': 'Tagak vs panganganak',
  'dataset.spurious-storks-vs-births.desc':
    'Mas malalaking bansa, mas maraming tagak at panganganak. Hindi sanhi ang mga ibon.',
  'dataset.real-sleep-vs-reaction-time.label': 'Tulog vs oras ng reaksiyon',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Mas mahabang tulog, mas mabilis na reaksiyon. Tunay na negatibong korelasyon — may makatuwirang mekanismo.',

  'tag.football.label': 'Saker',
  'tag.basketball.label': 'Basketbol',
  'tag.volleyball.label': 'Bolibol',
  'tag.swimming.label': 'Paglangoy',
  'tag.none.label': 'Wala',

  'population.gaussian.label': 'Kurbang kampana',
  'population.right-skewed.label': 'Pakanang baluktot',
  'population.bimodal.label': 'Dalawang taluktok',
  'population.uniform.label': 'Pantay',

  'venn.dice-even-or-prime.label': 'Dais: even o prime',
  'venn.class-sports-2set.label': 'Isports (2 set)',
  'venn.class-sports-3set.label': 'Isports (3 set)',
  'venn.custom.label': 'Pasadya',

  'tree.draw-without-replacement.label': 'Bunot na walang ibalik',
  'tree.custom.label': 'Pasadya',
  'tree.coin.heads': 'M',
  'tree.coin.tails': 'B',
  'tree.draw.start': 'Supot: 2 pula, 3 asul',
  'tree.draw.red': 'Pula',
  'tree.draw.blue': 'Asul',
  'tree.custom.start': 'Simula',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Histogram',
  'card.cumulative': 'Pinagsamang dalas',
  'card.box': 'Kahon at balahibo',
  'card.summary': 'Buod ng 5 bilang',
  'card.bar': 'Bar chart',
  'card.mode': 'Moda',
  'card.tag-frequency': 'Dalas ng tag',
  'card.mode-tag': 'Pinakamadalas na tag',
  'card.empty-no-order': 'Hindi naaangkop',
  'card.empty-multi': 'Hindi naaangkop',
  'card.numberline': 'Linya ng numero',
  'card.scatter': 'Scatter',
  'card.description': 'Ano ang nangyayari',
  'card.population': 'Populasyon',
  'card.sampling-distribution': 'Mean ng sample',
  'card.venn': 'Venn',
  'card.tree': 'Puno',
  'card.probabilities': 'Mga probabilidad',

  'param.dataset.label': 'Set ng datos',
  'param.column.label': 'Kolum',
  'param.bins.label': 'Mga bin',
  'param.shape.label': 'Unang hugis',
  'param.show-mean.label': 'Ipakita ang mean',
  'param.show-median.label': 'Ipakita ang median',
  'param.x-col.label': 'Kolum X',
  'param.y-col.label': 'Kolum Y',
  'param.show-regression.label': 'Linyang regression',
  'param.show-residuals.label': 'Mga labi',
  'param.show-confounder.label': 'Ipakita ang confounder',
  'param.population.label': 'Populasyon',
  'param.technique.label': 'Teknik',
  'param.sample-size.label': 'Laki ng sample',
  'param.stratum.label': 'Stratum',
  'param.bias.label': 'Bias',
  'param.mode.label': 'Mode',
  'param.preset.label': 'Preset',
  'param.universe.label': 'Laki ng uniberso',
  'param.show-prob.label': 'Ipakita ang probabilidad',
  'param.treat-as-numeric.label': 'Tratuhing numero',

  'stat.count': 'Bilang',
  'stat.mean': 'Mean',
  'stat.median': 'Median',
  'stat.range': 'Saklaw',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'Mga outlier',
  'stat.r': 'Pearson r',
  'stat.r2': 'r²',
  'stat.slope': 'Slope',
  'stat.intercept': 'Intercept',
  'stat.n': 'n',
  'stat.population-mean': 'Tunay na mean',
  'stat.latest-sample-mean': 'Mean ng sample',
  'stat.sample-mean-spread': 'SD ng sample mean',
  'stat.sample-count': 'Bilang ng sample',
  'outlier.upper': 'Itaas na outlier',
  'outlier.lower': 'Ibabang outlier',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'I-resample',
  'btn.run-100': 'Kumuha ng 100',
  'btn.stop': 'Hinto',
  'btn.clear-history': 'Burahin ang kasaysayan',

  'explainer.no-order': 'Walang ayos → walang cumulative, walang kahon.',
  'explainer.multi-no-iqr': 'Maramihan → walang depinisyon ang quartile / IQR.',
  'message.no-data': 'Walang datos.',
  'message.needs-quartiles': 'Kailangan ng ≥4 puntos para sa quartile.',
  'message.x-zero-variance': 'Variance ng X ay zero — walang linya.',
  'message.n-too-small': 'Maliit ang n.',
  'message.stratum-clamp': 'Mas kaunti ang rows ng stratum — lahat ay ginamit.',
  'message.siblings-sum-to-one': 'Dapat 1 ang kabuuan ng mga sibling.',
};
